import { TracksTypes } from '../../Interface/track'

export abstract class TrackResolverAbstract {
  abstract getTrack(id: number | string, type: TracksTypes): Promise<any>
}

export class StubTrackResolver extends TrackResolverAbstract {
  getTrack(id: number | string, type: TracksTypes) {
    return Promise.resolve(null)
  }
}
